import { Box } from "@mui/material";

const DEFAULT_SIZE = 26;

const ErrorIcon = ({ width = 10.425, height = 10.373 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      shapeRendering="geometricPrecision"
      style={{ color: "rgb(199, 47, 47)" }}
    >
      <path d="M7.86 2h8.28L22 7.86v8.28L16.14 22H7.86L2 16.14V7.86L7.86 2zM12 8v4M12 16h.01"></path>
    </svg>
  );
};

const SuccessIcon = ({ width = 26, height = 26, color = "#000" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      shapeRendering="geometricPrecision"
      style={{ color: "rgb(33, 169, 111)" }}
    >
      <path d="M8 11.857l2.5 2.5L15.857 9M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10z"></path>
    </svg>
  );
};

export const StatusIcon = ({
  success,
  width = DEFAULT_SIZE,
  height = DEFAULT_SIZE,
  successColor,
  errorColor,
}: {
  success: boolean;
  width?: number;
  height?: number;
  successColor?: string;
  errorColor?: string;
}) => {
  if (success) {
    return (
      <Box
        sx={(theme) => ({
          color: successColor ?? theme.palette.success.main,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "50%",
          width,
          height,
        })}
      >
        <SuccessIcon width={width} height={height} />
      </Box>
    );
  }

  return (
    <Box
      sx={(theme) => ({
        color: errorColor ?? theme.palette.error.main,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "50%",
        width,
        height,
      })}
    >
      <ErrorIcon width={width} height={height} />
    </Box>
  );
};
